import { render, staticRenderFns } from "./PaketMembership.vue?vue&type=template&id=0a40ecc5"
import script from "./PaketMembership.vue?vue&type=script&lang=js"
export * from "./PaketMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports